import { render, staticRenderFns } from "./BudgetDialog.vue?vue&type=template&id=56995024&scoped=true"
import script from "./BudgetDialog.vue?vue&type=script&lang=js"
export * from "./BudgetDialog.vue?vue&type=script&lang=js"
import style0 from "./BudgetDialog.vue?vue&type=style&index=0&id=56995024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56995024",
  null
  
)

export default component.exports